import React, { useEffect, useState } from "react";
import withStyles, { createUseStyles } from "react-jss";
import { inject } from "mobx-react";
import { replaceStaticHost } from "Helpers/ImageManager";
import userInfo from "Services/UserInfo";
import useCurrentRegion from "Services/useCurrentRegion";
import Metrika from "Services/Metrika";
import { SITE101_NOMERA } from "Constants/OrderTypes";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import { Contacts, FormLayout, Logo, Title } from "Layouts/TariffFormLayout";
import { Form, FormError } from "Layouts/Form";
import PhoneContainerProvider from "Containers/PhoneContainerProvider";
import { TextField } from "ComponentsUI/TextField";
import Button from "ComponentsUI/Button";
import { Col } from "ComponentsUI/Styles/Grid";
import TermsOfUse from "ComponentsUI/TermsOfUse";
import { useGetProviderConvergentQuery } from "./TariffOrderFormContainer.hooks";
import { AdditionalServiceCheckbox } from "./AdditionalServiceCheckbox";

const useInfoBlockStyle = createUseStyles((theme) => ({
	link: {
		borderBottom: "1px dashed",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "290px",
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
		},
	},
}));

const InfoBlock = ({ children }) => {
	const { root } = useInfoBlockStyle();

	return <div className={root}>{children}</div>;
};

const useStyles = createUseStyles({
	checkbox: {
		marginBottom: 27,
	},
});

function TariffFormContainer(props) {
	const popupModel = props.ApplicationModel.popupModel;
	const regionData = useCurrentRegion();
	const [fio, setFio] = useState("");
	const [phoneConnection, setPhone] = useState("");
	const classes = useStyles();
	const [wantAdditionalService, setWantAdditionalService] = useState(false);

	const [isError, setError] = useState(false);
	const [isSuccess, setSuccess] = useState(false);
	const { provider } = props.tariff;
	const { contacts } = provider;
	let region = null;
	//let siteCode = props.ApplicationModel.siteCode;
	let windowSizes = props.ApplicationModel.windowSizeModel.windowSizes;
	if (!regionData.loading) {
		region = regionData.data.region;
	}
	const onChangeFioHandler = (e) => {
		setFio(e.target.value);
		setError(!e.target.value.length);
	};

	const onChangePhoneHandler = (e) => {
		setPhone(e.target.value);
	};

	const onBlurPhone = () => {
		setError(phoneConnection.length !== 11 && phoneConnection.length !== 1);
	};

	const onFocusPhone = () => {
		setError(false);
	};

	const { convergent } = useGetProviderConvergentQuery({
		skip: !props.shouldAddConvergent,
		displayPrice: props.tariff.displayPrice,
		operatorUrl: provider.url_name,
		regionUrl: props.params.regionUrl,
		mobileInternet: +props.tariff?.mobile_new?.internet,
		mobileCalls: +props.tariff?.mobile_new?.calls,
	});

	const onClickConnectHandler = (e) => {
		if (fio.length < 2 || !props.validatePhone(phoneConnection)) {
			setError(true);
			return null;
		} else {
			setSuccess(true);
			let info = "";
			if (props.orderType == SITE101_NOMERA) {
				info = `Провайдер - ${provider.name};\nРегион - ${region.name};\n:Желаемый красивый номер телефона - ${props.tariff.phone}`;
			} else {
				Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.CLICK_SEND_MOBILE_ORDER, []);
				info = `Провайдер - ${provider.name};\nРегион - ${region.name};\nТариф - ${props.tariff.name}`;
			}

			let data = {
				fio: fio,
				phone_connection: phoneConnection,
				provider_id: provider.id,
				tariff_id: props.tariff.id,
				region_id: region.id,
				lead_form_type: userInfo(props.orderType),
				info: info,
				need_convergent: wantAdditionalService,
				convergent_tariff_id: convergent?.id || 0,
			};

			if (convergent) {
				data = {
					...data,
					convergent_display_price: convergent.displayPrice || 0,
					convergent_name: convergent.name || "Имя не найдено",
					convergent_tv_channels: convergent.tv?.channels || 0,
					convergent_tv_channels_hd: convergent.tv?.channels_hd || 0,
					convergent_sms: convergent.mobile_new?.sms || 0,
					convergent_sms_type: convergent.mobile_new?.sms_type || 0,
					convergent_internet: convergent.mobile_new?.internet || 0,
					convergent_internet_type: convergent.mobile_new?.internet_type || 0,
					convergent_calls: convergent.mobile_new?.calls || 0,
					convergent_calls_type: convergent.mobile_new?.calls_type || 0,
				};
			}

			if (props.apiOnly) {
				data["api_only"] = 1;
			}

			let infoUser = {
				name_popup: "TariffOrderOperator",
			};
			popupModel.setInfoUser(infoUser);

			props.sendOrder(props.orderType, data).then((dataPromise) => {
				if (!dataPromise) {
					props.sendOrderRepeat(props.orderType, data);
				}
			});
		}
	};

	let phone = "";

	if (provider) {
		if (provider.hasOwnProperty("contacts")) {
			if (provider.contacts.hasOwnProperty("phones")) {
				phone = contacts.phones.length && contacts.phones[0];
			}
		}
	}
	let text = props.text;
	let successButton = (
		<Button
			status={"secondaryAccent"}
			transparent={true}
			datatest={"give_feedback"}
			onClick={props.closeModal}
		>
			Спасибо!
		</Button>
	);

	return (
		<FormLayout height={"auto"} tariffView={true}>
			{!!props.providerInfo && (
				<Col xsHidden mdHidden lgHidden style={{ paddingRight: "55px" }}>
					<InfoBlock>
						<Logo>
							<img alt={"logo"} src={replaceStaticHost(provider.logo)} />
						</Logo>
						<Contacts>
							<div>{text.PHONE}</div>
							<div>
								{contacts.card == 3 ? (
									<a href={contacts.link} target="_blank">
										{text.show_phone}
									</a>
								) : (
									<PhoneContainerProvider phone={phone} />
								)}
							</div>
						</Contacts>
						{!isSuccess && (
							<Title>
								<span>{text.ORDER_CONNECT_TO_PROVIDER} </span>
								<span className={"bold"}>{provider.name}</span>
								<span>{` ${text.ON_OUR_SITE}`}</span>
							</Title>
						)}
					</InfoBlock>
				</Col>
			)}
			{!!props.providerInfo && (
				<Col
					smHidden
					style={{
						padding: 0,
						flexBasis: "auto",
						textAlign: "center",
					}}
				>
					<Logo>
						<img alt={"logo"} src={replaceStaticHost(provider.logo)} />
					</Logo>
				</Col>
			)}
			{!!props.providerInfo && (
				<Col smHidden style={{ padding: 0, flexBasis: "auto" }}>
					<Contacts>
						<div>{text.PHONE}</div>
						<div>
							{contacts.card == 3 ? (
								<a href={contacts.link} style={{ borderBottom: "1px dashed" }} target="_blank">
									{text.show_phone}
								</a>
							) : (
								<PhoneContainerProvider phone={phone} />
							)}
						</div>
					</Contacts>
				</Col>
			)}
			<Form
				type={"tariffForm"}
				isSuccess={isSuccess}
				successHeader={
					<>
						<div>{text.ORDER_SUCCESS_0}</div>
						<div>{text.ORDER_SUCCESS_4}</div>
						<div>{text.ORDER_SUCCESS_5}</div>
					</>
				}
				successButton={successButton}
			>
				{!!props.providerInfo && (
					<Col smHidden style={{ padding: 0, flexBasis: "auto" }}>
						{!isSuccess && (
							<Title>
								<span>{text.ORDER_CONNECT_TO_PROVIDER} </span>
								<span className={"bold"}>{provider.name}</span>
								<span>{` ${text.ON_OUR_SITE}`}</span>
							</Title>
						)}
					</Col>
				)}
				<TextField
					autocomplete="name"
					name="name"
					onChange={(e) => {
						onChangeFioHandler(e);
					}}
					onEnter={() => {
						onClickConnectHandler();
					}}
					label={text.ORDER_NAME_PLACEHOLDER}
					datatest="providers_provider_order_input_name"
					inputBackgroundColor={"transparent"}
					size={"medium"}
					autoFocus={!windowSizes.xs && !windowSizes.sm}
				/>
				<TextField
					autocomplete="tel"
					name="tel"
					onChange={(e) => {
						onChangePhoneHandler(e);
					}}
					onEnter={() => {
						onClickConnectHandler();
					}}
					label={text.ORDER_PHONE_PLACEHOLDER}
					placeholder={"+7"}
					datatest="providers_provider_order_input_tel"
					inputBackgroundColor={"transparent"}
					type={"phone"}
					size={"medium"}
					onBlur={onBlurPhone}
					onFocus={onFocusPhone}
				/>
				<FormError show={isError} hidden={!isError} tariffForm datatest={"incorrect_data"}>
					{text.SEND_ORDER_ERROR}
				</FormError>
				{convergent && (
					<div className={classes.checkbox}>
						<AdditionalServiceCheckbox
							checked={wantAdditionalService}
							onChange={() => setWantAdditionalService((prev) => !prev)}
							convergentCost={convergent.cost}
							text={text}
							channels={convergent.tv?.channels}
							speed={convergent.internet?.speed_in}
						/>
					</div>
				)}
				<Button
					status={"secondaryAccent"}
					fullWidth={true}
					datatest="order_form_input_connect_button"
					onClick={onClickConnectHandler}
				>
					{text.SEND_ORDER}
				</Button>
				{!props.providerInfo && <TermsOfUse buttonText={text.SEND_ORDER} isPopupOperator={true} />}
			</Form>
		</FormLayout>
	);
}

export default inject("ApplicationModel")(TariffFormContainer);
